import { isLocalEnv, isDevEnv, getAppEnv } from 'utils/env';

export function logLocalDev(...args: any[]) {
  if (isLocalEnv() || isDevEnv()) {
    return console.log('Logger', ...args);
  }
}
